/**
 * Sommaire d'article — écran 3b.
 *
 * Construit à la lecture depuis les titres réellement présents. Un sommaire
 * saisi à la main se désynchronise du corps de l'article dès la première
 * relecture ; celui-ci ne peut pas mentir.
 *
 * Les titres qui n'ont pas d'`id` en reçoivent un, dérivé de leur texte : les
 * ancres restent alors stables d'une visite à l'autre et partageables, ce
 * qu'un identifiant numéroté ne permettrait pas.
 */

import { Component } from '@theme/component';

class HeySommaire extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { liste } = this.refs;
    if (!liste) return;

    const cible = document.querySelector(this.dataset.cible || 'main') || document.body;
    const niveaux = (this.dataset.niveaux || 'h2').split(',').join(', ');

    const titres = [...cible.querySelectorAll(niveaux)].filter((t) => {
      // Ni les titres du sommaire lui-même, ni ceux d'une zone masquée.
      if (this.contains(t)) return false;
      if (t.closest('[hidden]')) return false;
      return t.textContent.trim().length > 0;
    });

    if (!titres.length) return; // pas de cadre vide

    const utilises = new Set();
    for (const titre of titres) {
      if (!titre.id) titre.id = identifiantUnique(titre.textContent, utilises);
      utilises.add(titre.id);

      const li = document.createElement('li');
      if (titre.tagName.toLowerCase() !== 'h2') li.className = 'hey-sommaire__sous';

      const a = document.createElement('a');
      a.href = `#${titre.id}`;
      a.textContent = titre.textContent.trim();
      li.append(a);
      liste.append(li);
    }

    this.hidden = false;
  }
}

/** « La méthode en trois étapes » → « la-methode-en-trois-etapes ». */
function identifiantUnique(texte, deja) {
  const base =
    texte
      .trim()
      .toLowerCase()
      .normalize('NFD')
      // `\p{M}` vise les marques combinantes, en source purement ASCII.
      // Une plage écrite avec les caractères eux-mêmes serait invisible dans
      // un éditeur et disparaîtrait au premier copier-coller.
      .replace(/\p{M}/gu, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'section';

  let id = base;
  let n = 2;
  while (deja.has(id) || document.getElementById(id)) id = `${base}-${n++}`;
  return id;
}

if (!customElements.get('hey-sommaire')) {
  customElements.define('hey-sommaire', HeySommaire);
}
